module.exports = __webpack_public_path__ + "static/media/icon-9.eb4afbc1.png";